import placeApprentissage from "../../resources/images/place-apprentissage.png"
import bonneAlternance from "../../resources/images/logo_LBA.png"

export const IMAGES: { src: string; url: string; title: string }[] = [
	{
		src: bonneAlternance,
		url: "https://labonnealternance.apprentissage.beta.gouv.fr/",
		title: "La Bonne Alternance",
	},
	{
		src: placeApprentissage,
		url: "https://www.pass.fonction-publique.gouv.fr/",
		title: "Place de l'apprentissage",
	},
]
